<script>
  // [08/23] https://tailwindui.com/components/application-ui/forms/radio-groups
  import {
    RadioGroup,
    RadioGroupLabel,
    RadioGroupOption,
  } from '@rgossiaux/svelte-headlessui';

  export let value;
  export let label;
  export let elements;
  export let note = undefined;
  export let link = undefined;
  export let lang = undefined;
  export let cssClass = undefined;

  value = value !== undefined ? value : elements[0].value;

  function getLabel (label) {
    if (typeof label === 'string') return label;
    else return label[lang];
  }
</script>

<div class="tailwind radio-group {cssClass || ''}">
  <div>
    <div class="flex items-center justify-between">
      <h2 class="text-sm font-medium leading-6 text-neutral-900 dark:text-white">
        {label}
      </h2>

      {#if note}
        {#if link}
          <a href={link} target="_blank" class="text-sm font-medium leading-6 text-blue-600 dark:text-blue-500 hover:text-blue-500 dark:hover:text-blue-400">
            {note}
          </a>
        {:else}
          <span class="text-sm leading-6 text-neutral-500 dark:text-neutral-400">
            {note}
          </span>
        {/if}
      {/if}
    </div>

    <RadioGroup value={value} on:change={e => (value = e.detail)} class="mt-2">
      <RadioGroupLabel class="sr-only">
        {label}
      </RadioGroupLabel>

      <div class="grid gap-2.5" class:grid-cols-2={elements.length === 2} class:grid-cols-3={elements.length === 3}>
        {#each elements as element (element.value)}
          <RadioGroupOption
            class={({ active, checked }) =>
              `${active ? 'outline-2 outline-blue-600 dark:outline-blue-500 outline-offset-2' : ''} ${checked ? 'bg-blue-600 dark:bg-blue-500 text-white dark:text-white hover:bg-blue-500 dark:hover:bg-blue-400' : 'ring-1 ring-inset ring-neutral-300 dark:ring-neutral-500 bg-white dark:bg-neutral-800 text-neutral-900 dark:text-white shadow-sm hover:bg-neutral-100 dark:hover:bg-neutral-700'} flex items-center justify-center rounded-md py-2 px-3 text-sm font-semibold flex-1 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 dark:focus-visible:outline-blue-500`}
            value={element.value}>

            <RadioGroupLabel as="span">
              {getLabel(element.label, lang)}
            </RadioGroupLabel>
          </RadioGroupOption>
        {/each}
      </div>
    </RadioGroup>
  </div>
</div>
